import get from "lodash/get";

export const getContentHeight = (store) => store.appState.contentHeight;

export const getCurrentPage = (store) => store.appState.currentPage;

export const getWebVersion = (store) =>
  get(store, "appState.system_config.app_web_version", "--");
